import React, { Component, useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";
import {
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import { SubjectDetailComponent } from "./Component";

import "./Style.css";
import useStores from "../../../../../utils/useStores";

const drawerWidth = 240;

const SubjectDetails = () => {
    const params = useParams<{
        user: string;
        subject: string;
    }>();
    
    if (!params.user || !params.subject) return null;

    const navigate = useNavigate();

    const rootStore = useStores();
    const subjectStore = rootStore.subjectStore;
    const profileStore = rootStore.profileStore;

    const [newObjectModalIsOpen, setNewObjectModalIsOpen] = React.useState(false);
    const [editObjectModalIsOpen, setEditObjectModalIsOpen] = React.useState(false);
    const [routeToNewObject, setRouteToNewObject] = React.useState(undefined);
    const [updateComponent, setUpdateComponent] = React.useState(0);
    const [submitSpinner, setSubmitSpinner] = React.useState(false);
    const [editObject, setEditObject] = React.useState(undefined);
    
    const [subject, setSubject] = React.useState(undefined);

    console.log(subject);
    useEffect(() => {
        const fetchSubject = async () => {
            await subjectStore.fetchOne(params.user!, params.subject!);
            const subject = subjectStore.subjects.get(`${params.user!}/${params.subject!}`);
            setSubject(subject);
        };
        fetchSubject();
    }, [params.user, params.subject]);


    useEffect(() => {
        if (routeToNewObject) {
            navigate(`/subjects/${subject_slug}/o/${routeToNewObject}`);
        }
    }, [routeToNewObject]);


    const createObject = (title: string, cb: Function) => {
        var component = this;

        setSubmitSpinner(true);

        rootStore.objectStore.create(
            params.user!,
            params.subject!,
            title,
            function(error: boolean, res: any) {
                if (!error) {
                    setSubmitSpinner(false);
                    setRouteToNewObject(res._id);
                    setUpdateComponent(updateComponent + 1);
                    cb();
                }
            }
        );
    }

    const removeSubjectObject = (category_slug: string) => {
        removeSubjectObject(category_slug);
    }

    const openEditObjectModal = (editObject: any) => {
        setEditObjectModalIsOpen(true);
        setEditObject(editObject);
    }

    const closeEditObjectModal = () => {
        setEditObjectModalIsOpen(false);
    }

    const subject_slug = `${params.user}/${params.subject}`;

    if (routeToNewObject)
        <Navigate
            to={`/subjects/${subject_slug}/o/${routeToNewObject}`}
        />;

    let html: JSX.Element = <div></div>;

    if (subject)
      return (
        <SubjectDetailComponent
          subject={subject}
          removeSubjectObject={removeSubjectObject}
          isLoggedIn={profileStore.isLoggedIn}
          createObject={createObject}
        />
      );

    return <div>Subject not found</div>;
};


export default observer(SubjectDetails);
